
<div class="view-component">
    <div class="view-component-body">
        <mat-card appearance="outlined" class="card">
            <mat-card-header>Descartar Cache do DD/User/Company/Contract</mat-card-header>
            <mat-card-content>
                <div class="central">
                    <button type="button"  color="primary"  mat-raised-button aria-label="Clear" (click)="descartarCache()">Executar
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" class="card">
            <mat-card-header>Recarregar Preferências</mat-card-header>
            <mat-card-content>
                <div class="central">
                    <button  type="button" color="primary" mat-raised-button aria-label="Clear" (click)="reloadPreferencia()" >Executar
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>